import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ListMixin from './listMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISAssetMgmtList',
  mixins: [ListMixin, userItemsPerListMixin],
  data: function data() {
    return {
      assetEditDialog: false,
      assetObject: null,
      indoor: false,
      outdoor: false,
      tableOptions: _objectSpread({}, defaultTableOptions),
      listPersistencePath: 'IsAssetMgmt.list'
    };
  },
  computed: {
    operationalStatus: function operationalStatus() {
      return {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      };
    },
    searchCategories: function searchCategories() {
      return [{
        value: 'title',
        text: this.$i18n_t('Common.help.titel')
      }, {
        value: 'id',
        text: "Asset ".concat(this.$i18n_t('Common.id'))
      }, {
        value: 'floorDtwin.name',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor')
      }, {
        value: 'floorDtwin.number',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.map.floorLabel')
      }, {
        value: 'tag',
        text: this.$i18n_t('IS.AssetMgmt.list.category')
      }, {
        value: 'zone',
        text: this.$i18n_t('DigitalTwin.DigitalTwin.types.zone')
      }];
    },
    localizedTableOptions: function localizedTableOptions() {
      return {
        headers: [{
          text: this.$i18n_t('Common.id'),
          value: 'id',
          align: 'right',
          sortable: true
        }, {
          text: this.$i18n_t('Common.help.titel'),
          value: 'title',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.category'),
          value: 'category',
          sortable: false
        }, {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.types.floor'),
          sortable: true,
          value: 'floorDtwin.title'
        }, // {
        //   text: this.$i18n_t('Common.tenant'),
        //   sortable: true,
        //   value: 'tenant.name',
        // },
        {
          text: this.$i18n_t('IS.AssetMgmt.list.lastSeen'),
          value: 'lastSeen',
          sortable: true
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.details.operationalStatus'),
          value: 'operationalStatus',
          sortable: true
        }, {
          text: this.$i18n_t('IS.AssetMgmt.list.device'),
          value: 'device',
          sortable: false
        }, {}],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    },
    headerBG: function headerBG() {
      return './img/consumer.png';
    }
  },
  created: function created() {
    this.fetchType = 'trackable';
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    this.indoor = this.fetchOptions.indexOf('indoor') >= 0;
    this.outdoor = this.fetchOptions.indexOf('outdoor') >= 0;
  },
  methods: {
    toggleIndoor: function toggleIndoor() {
      if (this.fetchOptions.indexOf('indoor') >= 0) {
        this.fetchOptions = this.fetchOptions.filter(function (o) {
          return o !== 'indoor' && o !== 'outdoor';
        });
      } else {
        this.fetchOptions = this.fetchOptions.filter(function (o) {
          return o !== 'outdoor';
        });
        this.fetchOptions.push('indoor');
      }

      this.fetchList(true);
      this.indoor = !this.indoor;
    },
    toggleOutdoor: function toggleOutdoor() {
      if (this.fetchOptions.indexOf('outdoor') >= 0) {
        this.fetchOptions = this.fetchOptions.filter(function (o) {
          return o !== 'outdoor' && o !== 'indoor';
        });
      } else {
        this.fetchOptions = this.fetchOptions.filter(function (o) {
          return o !== 'indoor';
        });
        this.fetchOptions.push('outdoor');
      }

      this.fetchList(true);
      this.outdoor = !this.outdoor;
    },
    handleAssetEdit: function handleAssetEdit(item) {
      this.assetObject = item;
      this.assetEditDialog = true;
    },
    handleRowClick: function handleRowClick(item) {
      this.$router.push("/is-assetmgmt/assets/".concat(item.id));
    },
    detailTableHeaderColClass: function detailTableHeaderColClass(header, props) {
      var classes = ["text-".concat(header.align || 'start')];

      if (header.sortable && ['title', 'id', 'floorDtwin.title'].indexOf(header.value) < 0) {
        classes.push('sortable');
      }

      var values = [header.value];

      if (props.options.sortBy && props.options.sortBy.length && values.indexOf(props.options.sortBy[0]) >= 0) {
        classes.push('active');

        if (props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0]) {
          classes.push('desc');
        } else {
          classes.push('asc');
        }
      }

      return classes.join(' ');
    },
    detailTableHeaderClasses: function detailTableHeaderClasses(props) {
      var sortBy = props.options.sortBy && props.options.sortBy.length ? props.options.sortBy[0] : 'none';
      var sortDesc = props.options.sortDesc && props.options.sortDesc.length && props.options.sortDesc[0];
      return {
        text: {
          title: "header-item-sortable ".concat(sortBy === 'title' ? 'header-active' : 'header-nonactive'),
          id: "header-item-sortable ".concat(sortBy === 'id' ? 'header-active' : 'header-nonactive'),
          floorDtwinTitle: "header-item-sortable ".concat(sortBy === 'floorDtwin.title' ? 'header-active' : 'header-nonactive')
        },
        icon: {
          title: sortBy === 'title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          id: sortBy === 'id' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive',
          floorDtwinTitle: sortBy === 'floorDtwin.title' ? sortDesc ? 'icon-desc' : '' : 'icon-nonactive'
        }
      };
    },
    closeEvent: function closeEvent(e) {
      if (e) {
        this.fetchList();
      }

      this.assetEditDialog = false;
    }
  }
};